import {
  NaturalWrittenDivisionTwoByOneExactTask,
  NaturalWrittenDivisionThreeByOneExactTask,
  NaturalWrittenDivisionThreeByTwoExactTask,
  NaturalWrittenDivisionFourByTwoExactTask,
  NaturalWrittenDivisionTwoByOneRemainderTask,
  NaturalWrittenDivisionThreeByOneRemainderTask,
  NaturalWrittenDivisionFourByTwoRemainderTask,
} from "./podtemat4_dzielenie_pisemne_types/NaturalWrittenDivisionTask";

export const registry = {
  NaturalWrittenDivisionTwoByOneExactTask,
  NaturalWrittenDivisionThreeByOneExactTask,
  NaturalWrittenDivisionThreeByTwoExactTask,
  NaturalWrittenDivisionFourByTwoExactTask,
  NaturalWrittenDivisionTwoByOneRemainderTask,
  NaturalWrittenDivisionThreeByOneRemainderTask,
  NaturalWrittenDivisionFourByTwoRemainderTask,
};

export function generateTasks() {
  return [
    NaturalWrittenDivisionTwoByOneExactTask.generateTask(),
    NaturalWrittenDivisionThreeByOneExactTask.generateTask(),
    NaturalWrittenDivisionThreeByTwoExactTask.generateTask(),
    NaturalWrittenDivisionFourByTwoExactTask.generateTask(),
    NaturalWrittenDivisionTwoByOneRemainderTask.generateTask(),
    NaturalWrittenDivisionThreeByOneRemainderTask.generateTask(),
    NaturalWrittenDivisionFourByTwoRemainderTask.generateTask(),
  ];
}

export function renderTask(task) {
  return registry[task.type]?.renderTask(task) || null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return registry[task.type]?.renderInput(task, userAnswer, onChange, disabled) || null;
}

export function checkAnswer(task, userAnswer) {
  return registry[task.type]?.checkAnswer(task, userAnswer) || false;
}

export function renderAnswer(task) {
  return registry[task.type]?.renderAnswer(task) || null;
}

export function renderExplanation(task) {
  return registry[task.type]?.renderExplanation(task) || null;
}

export function renderUserAnswer(task, userAnswer) {
  return registry[task.type]?.renderUserAnswer(userAnswer) || null;
}
